module.exports = __webpack_public_path__ + "img/loginfel.1ddbe8e2.png";